import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=a59a96c0&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a59a96c0')) {
      api.createRecord('a59a96c0', component.options)
    } else {
      api.reload('a59a96c0', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=a59a96c0&", function () {
      api.rerender('a59a96c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287ro39aj7S7n/JS/comp/ImgFallback.vue"
export default component.exports